import React from "react";
import { createPortal } from "react-dom";

export const Modal = ({ isOpen, coverApp, close, children }) => {
  if (!isOpen) {
    return null;
  }

  const ModalDom = (
    <div
      id="modal"
      onClick={() => {
        setTimeout(() => {
          // close();
        }, 10);
      }}
      style={{
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        position: "fixed",
        zIndex: "5",
        display: "flex",
        lineHeight: "1.2em",
        justifyContent: "center",
        alignItems: "center",

        // backgroundColor: "red",
        backgroundColor: "rgba(67, 67, 75, 0.7)",
      }}
    >
      {children}
    </div>
  );
  if (!coverApp) return ModalDom;
  // const target = usePortal("App");
  const target = document.body;
  return createPortal(ModalDom, target);
};
